module.exports = __webpack_public_path__ + "static/media/03_avatar_animal.61e7726a.png";